/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import type { Equal, ExpectTrue } from '../types/validation'

import { type CmsIcon, CmsIconSchema } from './icon'

/* TypeScript */
export type ListItemApiProps = {
  technicalName?: Maybe<string>
  icon: CmsIcon
  text?: Maybe<string>
}

/* Schemas */
export const ListItemSchema = z.object({
  technicalName: z.nullish(z.string()),
  icon: CmsIconSchema,
  text: z.nullish(z.string()),
})

/* Schemas validation */
type TestListItem = ExpectTrue<
  Equal<ListItemApiProps, z.infer<typeof ListItemSchema>>
>
